import { StringsType } from "./en"

export const es: StringsType = {
  bubbleExpiration: {
    expiredTitle: "Premium gratuito ha expirado",
    expiredSubtitle:
      "Actualiza a Premium para la mejor experiencia de PhotoVault",
    expiredSubtitlePremium:
      "Actualiza a Premium para una gran experiencia de PhotoVault",
    expiredSubtitleUltimate:
      "Actualiza a Ultimate para la mejor experiencia de PhotoVault",
    trashRecovery: "Recuperación",
    cloudVault: "Cloud Vault",
    spaceSaver: "Space Saver",
    noAds: "Sin anuncios",
    everyPremiumFeature: "Obtén todas las\nfunciones Premium",
    everyUltimateFeature: "Obtén todas las\n funciones Ultimate",
    unlockUltimateTools:
      "Desbloquea todas las herramientas de privacidad en la aplicación.",
    cloudVaultUltimate: "Cloud Vault - 1,000 GB",
    organizationPlus: "Organización+",
    organizationPlusDesc: "Crear sub-álbumes, encontrar duplicados y más.",
    perMonth: "por mes",
    perYear: "por año",
    justOnce: "solo una vez",
    lifetime: "De por vida",
    threeMonths: "3 Meses",
    lifetimeTitle: "Plan de por vida",
    lifetimeDescription:
      "El plan de por vida estará disponible pronto. ¡Mantente atento a las actualizaciones!",
    lifetimeFeature1: "Pago único",
    lifetimeFeature2: "Acceso de por vida a todas las funciones",
    lifetimeFeature3: "Mejor valor para usuarios a largo plazo",
    lifetimeCta: "Comprar Lifetime",
    lifetimeSheetDisclaimer:
      "Copia de seguridad en la nube (50GB) incluida por 5 años.",
    lifetimeSheetDisclaimerDetailed:
      "5 años de copia de seguridad de Cloud Vault (50 GB) están incluidos con tu plan de por vida. Después, serás elegible para una suscripción de Cloud Vault con descuento disponible solo para miembros de por vida. Todas las características Premium siempre permanecerán disponibles sin costo adicional.",
    lifetimeDisclaimerCloudStorage:
      "5 años de copia de seguridad de Cloud Vault (50 GB) están incluidos con tu plan de por vida.",
    lifetimeDisclaimerAfterPeriod:
      "Después de 5 años, serás elegible para una suscripción de Cloud Vault con descuento disponible solo para miembros de por vida.",
    lifetimeDisclaimerPremiumFeatures:
      "Todas las características Premium siempre permanecerán disponibles sin costo adicional.",
    monthly: "Mensual",
    yearly: "Anual",
    selectPlan: "Selecciona un plan para continuar",
    unlockPrivacyTools: "Desbloquea excelentes herramientas de privacidad.",
    cloudVaultGB: "Cloud Vault - 50 GB",
    secureBackups: "Copias de seguridad seguras que permanecen cifradas.",
    freeUpSpace: "Libera espacio en tu teléfono.",
    recoverDeleted: "Recupera elementos eliminados de la papelera.",
    fullExperience: "La experiencia completa sin interrupciones.",
    restorePurchases: "Restaurar compras",
    basicTitle: "Private Photo Vault Basic",
    free: "GRATIS",
    basicDescription:
      "Basic es la versión gratuita de PhotoVault. Aún protege tus fotos importantes detrás de una pantalla PIN y te ofrece buenas características de privacidad.",
    switchToBasic: "Cambiar a Basic",
    termsOfService: "Términos de servicio",
    privacy: "Privacidad",
    switchToPremium: "Cambiar a Premium",
    switchToUltimate: "Cambiar a Ultimate",
    premiumExpiredTitle: "Premium ha caducado",
    ultimateExpiredTitle: "Ultimate ha caducado",
    renewSubtitle: "Renueva para la mejor experiencia de Private Photo Vault",
    selectPlanOrSwitchToPro: "Selecciona un plan o cambia a Pro gratis",
    selectPlanOrSwitchToBasic: "Selecciona un plan o cambia a Basic gratis",
    proTitle: "Private Photo Vault - Pro",
    purchased: "Comprado",
    proDescription:
      "Como compraste previamente la versión Pro de pago único, podrás seguir usando todas las funciones Pro por las que pagaste.",
    switchToPro: "Cambiar a Pro",
    subscribeFor: (price: string) => `Suscríbete por ${price}/año`,
    subscribeForMonth: (price: string) => `Suscríbete por ${price}/mes`,
    billedPerYear: (price: string) => `facturado ${price} al año`,
    oneStepSubtitle:
      "Actualiza a Premium para la mejor\nexperiencia de Private Photo Vault",
    oneStepSubtitleUltimate:
      "Actualiza a Ultimate para la mejor\nexperiencia de Private Photo Vault",
    purchaseWithAppStore: "Comprar con App Store",
  },
  title: "Acceso ilimitado a todas las funciones",
  freeTrial: "Prueba gratuita",
  startPlan: "Empezar Plan",
  pricePerMonth: (price: any) => `${price}/mes`,
  pricePerYear: (price: any) => `facturado como ${price}/año`,
  freeTrialDescriptionYearly: (days: number, price: string) =>
    `${days} días gratis, luego ${price}/año. Cancela cuando quieras`,
  freeTrialDescriptionMonthly: (days: number, price: string) =>
    `${days} días gratis, luego ${price}/mes. Cancela cuando quieras`,
  discount: (discount: number) => `${discount}% DESCUENTO`,
  new: "nuevo",
  trashRecovery: "Recuperar papelera",
  adFree: "Experiencia sin anuncios",
  breakIn: "Informe de intrusión: foto y GPS",
  wireless: "Envío de foto inalámbrico",
  decoy: "Contraseña de señuelo",
  pattern: "Patrón",
  appDisguise: "Ocultar aplicación",
  comingSoon: "próximamente",
  subscriptionTerms: "Términos de Suscripción:",
  terms:
    "Se le cobrará a la Cuenta de iTunes al momento de confirmar la compra. La suscripción se renueva automáticamente a menos que se cancele la renovación automática al menos 24 horas antes de que finalice el período actual. A la cuenta se le cobrará la renovación dentro de las 24 horas anteriores al cierre del período actual. Puedes gestionar tu suscripción y desactivar la renovación automática desde la Configuración de tu Cuenta después de la compra.",
  privacy: "Privacidad",
  alreadyPurchased: "¿Ya comprado?",
  termsButton: "Términos",
  monthly: "AL MES",
  yearly: "ANUALMENTE",
  popular: "POPULAR",
  save: (discount) => `AHORRA ${discount}%`,
  anniversaryTitle: (discount) => `Oferta de Aniversario - AHORRA ${discount}%`,
  blackFridayTitle: (discount) => `Viernes Negro - AHORRA ${discount}%`,
  year: "año",
  years: "años",
  hour: "hora",
  hours: "horas",
  minute: "minuto",
  minutes: "minutos",
  second: "segundo",
  seconds: "segundos",
  promoSubtitle: (hours) =>
    `Date prisa, esta oferta solo durará ${hours} horas`,
  offerExpires: "Hasta que la oferta caduque",
  unlockDeal: "Desbloquear oferta",
  blackFridayPaywallTitle: "Oferta de Black Friday",
  anniversaryPaywallTitle: "Tu oferta de aniversario 🎉",
  blackFridayPaywallSubtitle:
    "¡No te pierdas esta oferta única para el Black Friday! Obtén grandes ahorros en nuestra suscripción anual.",
  anniversaryPaywallSubtitle: (years: number, discount: number) =>
    `¡Felicidades por ${years} años con nosotros! Para celebrarlo, aquí tienes un descuento del ${discount}% en Premium. ¡Gracias por tu lealtad!`,
  blackFridayAnnualTitle: "Tu oferta de Black Friday 🎉",
  anniversaryAnnualTitle: "Tu oferta de aniversario 🎉",
  oneYear: "1 año",
  oneMonth: "1 mes",
  lockedIn: "Este precio anual quedará bloqueado PARA SIEMPRE",
  subtitleFixed: "¡Date prisa, esta oferta terminará pronto!",
  importTitle: "Comienza tu bóveda",
  importSubtitle: "¡Es 100% privado!",
  importInfo: "Añade fotos y videos que quieras mantener ocultos y seguros.",
  importCTA: "Añadir a la bóveda",
  skip: "Saltar",
  totalMonthsPrice: (price: string) => `12 meses • ${price}`,
  monthlyPrice: (price: string) => `${price} / mes`,
  oneTimeOffer: {
    title: "Tu oferta única",
    subTitle: "Una vez que cierras tu oferta única, ¡se va!",
    claim: "Reclama tu oferta única",
  },
  returnOffer: {
    monthly: (price: string) => `tan bajo como ${price}/mes`,
    title: "Tu Oferta Exclusiva de Regreso",
    subTitle:
      "Reactiva tu membresía hoy a una tarifa especial! Disponible por tiempo limitado",
    discountTitle: "Descuento Especial",
    cta: "Reactivar Ahora",
    discountSubTitle: "Oferta por tiempo limitado",
  },
  off: "DESCUENTO",
  special: "ESPECIAL",
  yearlyPlan: "Plan Anual",
  monthlyPlan: "Plan Mensual",
  subscribe: "Suscribirse",
  cancelAnytime: "Cancelar en cualquier momento",
  freeTrialPaywall: {
    title: "Cómo funciona tu prueba gratuita",
    firstStep: {
      title: "Ahora",
      subtitle:
        "Desbloquea el acceso ilimitado a Private Photo Vault y nunca más te preocupes por que alguien vea tus fotos privadas",
    },
    secondStep: {
      title: "Hoy: Comienza tu prueba gratuita",
      subtitle:
        "Desbloquea el acceso completo a PhotoVault. No se te cobrará hoy.",
    },
    thirdStep: {
      title: "En 7 días",
      subtitle:
        "Se te cobrará este día. Cancela en cualquier momento antes, sin problemas.",
    },
    whatsIncluded: "Ver lo que está incluido",
    viewAllPlans: "Ver todos los planes",
    startTrial: "Comenzar prueba gratuita",
    footerTitle: (yearlyPrice, monthlyPrice) =>
      `7 días GRATIS y luego ${yearlyPrice}/año\n(${monthlyPrice} al mes)`,
    footerDisclaimer:
      "Cancela en cualquier momento antes de que termine tu prueba. Solo se te cobrará después de 7 días",
    featureList: {
      title: "¿Qué es Private Photo Vault?",
      infoTitle: "100% Privado y Seguro",
      infoSubtitle: "Protege tus datos y previene el acceso no autorizado",
      subTitle: "Hazte Premium y obtén acceso a:",
    },
    comparePlans: {
      monthly: "Mensual",
      yearly: "Anual",
      ultimateYearly: "Ultimate anual",
      threeMonths: "3 meses",
      freeFor: (days) => `Gratis por ${days} días`,
      monthlyPrice: (price) => `solo ${price}/mes`,
      dailyPrice: (price) => `solo ${price}/día`,
      cta: "Continuar",
    },
  },
  comparePlans: {
    title: "Comparar planes",
    compare: "Comparar",
    freeTitle: "Gratis",
    basicTitle: "Básico",
    premiumTitle: "Premium",
    ultimateTitle: "Ultimate",
    unlockPremium: "Desbloquear Premium",
    unlockUltimate: "Desbloquear Ultimate",
    choose: "Elige un plan",
  },
  features: {
    organizationPlus: "Organización+",
    securityPlus: "Seguridad+",
    duplicateDetection: "Detección de duplicados",
    faceDownLock: "Bloqueo con pantalla hacia abajo",
    customIcons: "Íconos personalizados",
    encryptedStorage: "Almacenamiento de fotos encriptado",
    unlimitedAlbums: "Álbumes ilimitados",
    browser: "Navegador web seguro",
    camera: "Cámara privada",
    subalbums: {
      title: "Subálbumes",
      description:
        "Crea múltiples niveles de subálbumes para organizar tu contenido de manera eficiente.",
    },
    filteringAndSearching: {
      title: "Filtrado y búsqueda",
      description:
        "Busca en tus álbumes y aplica filtros para encontrar tipos de contenido específicos.",
    },
    alphanumericPasscode: {
      title: "Contraseña alfanumérica",
      description:
        "Mejora la seguridad de tu aplicación utilizando una contraseña alfanumérica.",
    },
    dualLock: {
      title: "Requiere contraseña + Face ID",
      description:
        "Para mayor seguridad, requiere tanto tu contraseña como Face ID cada vez que ingreses a la aplicación.",
    },
    locationBasedLock: {
      title: "Bloqueo basado en la ubicación",
      description:
        "Permite desbloquear la aplicación solo en ubicaciones GPS aprobadas.",
    },
  },
  gotIt: "¡Entendido!",
  promo: {
    premiumSave: (percent: string) => `AHORRA ${percent}% EN PREMIUM`,
    monthly: (price: string) => `Solo ${price}/mes`,
    yearly: (price: string) => `${price}/año`,
    limited: "TIEMPO LIMITADO",
    claimOffer: "Reclamar oferta",
    seconds: (count: number) => (count == 1 ? "SEGUNDO" : "SEGUNDOS"),
    minutes: (count: number) => (count == 1 ? "MINUTO" : "MINUTOS"),
    oneTimeOffer: "OFERTA ÚNICA",
    normalFee: "tarifa normal",
    backTo: "volver a",
    yearlyShort: (price: string) => `${price}/anual`,
  },
  premiumToUltimateBlackFriday: {
    title: "OFERTA DE BLACK FRIDAY",
    subTitle: "HAZTE ULTIMATE",
    cloud: {
      title: "1,000GB de almacenamiento en la nube",
      description: "Almacenamiento seguro en la nube para más de 500,000 fotos",
    },
    duplicateDetection: {
      description: "Localiza y elimina imágenes duplicadas",
    },
    organizationPlus: {
      description: "Crea subálbumes, filtra y busca tus fotos",
    },
    securityPlus: {
      description:
        "Mayor seguridad con código alfanumérico, bloqueo basado en ubicación y más",
    },
    timeRemaining: "TIEMPO RESTANTE",
    saleBanner: "VENTA MEGA LIMITADA",
    saleTitle: "Oferta de Black Friday 🎉",
    bannerTitle: (discount: number) =>
      `${discount}% de descuento en Black Friday`,
    bannerCTA: "Reclamar Oferta",
    monthPrefix: "12 meses • ",
    perMonthPrice(price: string) {
      return `${price} / mes`
    },
    monthly: "Mensual",
    ultimateLaunch: {
      title: "MEJORA A Ultimate",
      saleTitle: "Oferta de Lanzamiento Ultimate 🚀",
      bannerTitle: (discount) => `Lanzamiento Ultimate - AHORRA ${discount}%`,
    },
  },
  blackFridayNoFeatures: {
    title: "BLACK FRIDAY",
    lessThanCoffee: "Menos que un café.",
    dontWait: "¡No esperes! Esta oferta se irá pronto",
    whatWaiting: "¿Qué estás esperando?",
    claimOffer: "RECLAMA TU OFERTA ÚNICA",
    moneyBack: "Garantía de devolución de dinero",
  },
  cyberMonday: {
    title: "CYBER MONDAY",
    subTitle: "OBTÉN ULTIMATE",
    cloud: {
      title: "1.000 GB de Almacenamiento en la Nube",
      description: "Almacenamiento en la nube seguro para más de 500.000 fotos",
    },
    duplicateDetection: {
      description: "Localiza y elimina imágenes duplicadas",
    },
    organizationPlus: {
      description: "Crea subálbumes, filtra y busca en tus fotos",
    },
    securityPlus: {
      description:
        "Seguridad mejorada con código alfanumérico, bloqueo por ubicación y más",
    },
    timeRemaining: "TIEMPO RESTANTE",
    saleBanner: "OFERTA CYBER LIMITADA",
    saleTitle: "Oferta Cyber Monday",
    bannerTitle: (discount: number) =>
      `${discount}% de descuento en Cyber Monday`,
    bannerCTA: "Reclamar Oferta",
    monthPrefix: "12 meses • ",
    perMonthPrice(price: string) {
      return `${price} / mes`
    },
    monthly: "Mensual",
    ultimateLaunch: {
      title: "MEJORA A Ultimate",
      saleTitle: "Oferta de Lanzamiento Ultimate",
      bannerTitle: (discount: number) =>
        `Mejora a Ultimate - AHORRA ${discount}%`,
    },
  },
  beforeYouGo: {
    title: "Espera - Antes de que te vayas",
    subtitle: "Mantén tus fotos seguras y privadas",
    subtitle2: "Consigue 7 días de Premium completamente gratis.",
    cta: "Inicia tu Prueba Gratis",
    cancelTitle:
      "Cancela en cualquier momento antes de que termine tu prueba y no serás cobrado hasta que se completen los 7 días.",
    skipCta: "No, gracias",
  },
  enableTrial: "¿No estás seguro aún? Activa la prueba gratuita",
  startTrial: "Inicia la prueba gratuita",
  trialActivated: (days) => `PRUEBA DE ${days} DÍAS ACTIVADA`,
  specialOffer: {
    enabledTitle: "Oferta especial activada",
    trialTitle: "Reclama tu prueba gratuita adicional de 7 días",
    expirationTitle: "¡Tu suscripción está por caducar!",
    expirationSubtitle: "¡Renueva tu suscripción a un precio especial!",
    priceBoxExpiration: {
      title: "Oferta especial de renovación",
      offerName: "Plan anual",
      ctaTitle: "Reclamar oferta especial",
    },
    priceBoxTrial: {
      title: "Oferta exclusiva de prueba gratuita adicional de 7 días",
      offerName: "Prueba adicional de 7 días",
      ctaTitle: "Reclamar prueba gratuita adicional",
    },
  },
  premiumToUltimate: {
    titleLine1: "ACTUALIZACIÓN A ULTIMATE",
    titleLine2: "OFERTA ÚNICA",
    megaSaleBanner: "MEGA OFERTA POR TIEMPO LIMITADO",
    upgradeTitle: "Oferta de Actualización a Ultimate",
    yearlySubtitlePrefix: "12 meses •",
    monthlyPriceSuffix: "/ mes",
  },
  monthlyToYearly: {
    titleLine1: "Actualización Anual",
    titleLine2: "Oferta Única",
    subtitleWarning: "¡Si cierras esta oferta única, desaparecerá!",
    specialLabel: "ESPECIAL",
    offerTitle: "Aprovecha tu oferta única",
    offerName: "Plan Anual",
    subscribeButton: "Suscribirse",
    cancelAnytime: "Cancela en cualquier momento",
    yearlySubtitlePrefix: "12 meses •",
    monthlyPriceSuffix: "/ mes",
  },
  expiration: {
    warmup: {
      close: "CERRAR",
      subtitle:
        "Mantén tus fotos SEGURAS y RECUPERABLES si pierdes tu teléfono o te lo roban",
      features: {
        cloudVault: {
          title: "Cloud Vault",
          subtitle: "Copia de seguridad cifrada de tus archivos",
        },
        cloudVaultUltimate: {
          title: "Cloud Vault",
          subtitle: "1.000 GB de almacenamiento en Cloud Vault",
        },
        reviews: {
          title: "Más de 500,000 valoraciones de 5 estrellas",
          subtitle: "Confiado por millones",
        },
        noAds: {
          title: "Sin anuncios",
          subtitle: "Experiencia sin publicidad",
        },
        organizationPlus: {
          title: "Organization+",
          subtitle: "Subálbumes, mejor filtrado y más",
        },
      },
      footer: "¡Y todas las funciones!",
      switchToPremium: "Cambiar a Premium",
      switchToUltimate: "Cambiar a Ultimate",
      titlePremium: "¡Tu Premium ha caducado!",
      titleUltimate: "¡Tu Ultimate ha caducado!",
      popular: "POPULAR",
      perMonth: "por mes",
      perYear: "al año",
    },
    titlePremium: "Premium ha caducado",
    titleUltimate: "Ultimate ha caducado",
    subtitlePremium:
      "Renueva Premium para conservar todas tus funciones o cambia a Basic gratis",
    subtitleUltimate:
      "Renueva Ultimate para conservar todas tus funciones o cambia a Basic gratis",
    basicButton: "Cambiar a Basic",
    basicTitle: "¿Qué es Basic?",
    basicDescription:
      "Basic es la versión gratuita de la app. Todavía puedes proteger tus fotos y vídeos con un PIN. Sin embargo, perderás acceso al respaldo cifrado de Cloud Vault y todas las demás funciones Premium",
  },
  animated: {
    title: "Elige tu plan",
    yearlyPrice: (price: string) => `Solo ${price} al año`,
    subtitle: "Renovación automática. Cancela cuando quieras",
    cta: "Continuar",
    trial: "Prueba gratuita activada",
    breakinShort: "Informe de intrusión",
    unlimitedPhotos: "Fotos ilimitadas",
  },
  choosePlanTitle: "Elige Tu Plan",
  socialProof: {
    titleWithTrial: "Prueba Private Photo Vault\nGratis por 7 Días",
    title: "Prueba Private Photo Vault",
    continueForFree: "Continuar gratis",
    continue: "Continuar",
    cancelAnytime: "Cancela cuando quieras",
    mostPopular: "Más popular",
    twelveMonths: "12 Meses",
    oneMonth: "1 Mes",
    yearlySubtitle: (monthlyPrice: string, yearlyPrice: string) =>
      `${monthlyPrice}/mes, facturado como ${yearlyPrice}/año`,
    monthlySubtitle: (price: string) => `${price}/mes`,
  },
  yearlyOnlyAppStore: {
    yearly: "Anual",
    billedYearly: (price: string) => `${price} facturado anualmente`,
    perMonth: (price: string) => `${price}/mes`,
    startTrial: (days: number) => `Inicia prueba de ${days} días`,
    purchaseWithAppStore: "Comprar con App Store  (sin prueba)",
    purchaseImmediately: "Comprar de inmediato  (sin prueba)",
  },
  multistep: {
    lockTitle: "Bloquea fotos privadas",
    subtitle: {
      line1: "Ofrecemos",
      line2: "7 días gratis",
      line3: "para que todos puedan proteger sus fotos",
    },
    subtitleReminder: {
      line1: "Recibirás un recordatorio ",
      line2: "2 días ",
      line3: "antes de que finalice tu prueba.",
    },
    noPaymentNow: "No se requiere pago ahora",
    startFreeWeek: "Comienza tu semana GRATIS",
    payTitle: "7 días gratis",
    afterPrice: (price: string) => `luego ${price} / mes`,
    afterBilling: (price: string) =>
      `(facturado como ${price} anuales después de la prueba)`,
    footerTitle: (price) => `Gratis por 7 días. Luego, ${price}/año`,
    footerMonthlyTitle: (price) => `Se te cobrará ${price} inmediatamente.`,
    headerTitle: "Prueba gratuita de 7 días",
    anual: "Anual",
    monthly: "Mensual",
    noTrial: "Sin prueba gratuita",
    yearlyPrice: (price) => `${price} / Año`,
  },
  oneTimeOfferTitle: "OFERTA ÚNICA",
  unlockPremiumFor: "Desbloquea Premium Anual por",
  oneTimeOfferSubtitle: "Esta es una oferta única",
  lowestPrice: "EL PRECIO MÁS BAJO DE TODOS",
  summerSale: {
    title: "REBAJAS DE VERANO",
    tagline: "El sol lo ve todo... ¡excepto lo que hay en tu caja fuerte!",
    timeRemaining: "La oferta expira pronto",
    limitedTimeOffer: "Oferta por tiempo limitado",
    savePercent: (percent: number) => `Ahorra ${percent}%`,
    bannerSubtitle: (price: string) => `Obtén Premium por ${price}`,
    bannerSubtitleUltimate: (price: string) => `Obtén Ultimate por ${price}`,
    getPremium: "Obtén privacidad Premium",
    getUltimate: "Obtén privacidad Ultimate",
    hours: "horas",
    minutes: "minutos",
    seconds: "segundos",
    features: {
      premiumFeature: {
        title: "Obtén todas las funciones Premium",
        description: "Herramientas Premium que protegen tu privacidad.",
      },
      cloudVault: {
        title: "Cloud Vault - 50 GB",
        description: "Copias de seguridad seguras que permanecen cifradas.",
      },
      noAds: {
        title: "Sin anuncios",
        description: "La experiencia completa sin interrupciones.",
      },
      faceDownLock: {
        title: "Bloqueo boca abajo",
        description: "Bloquea la app al instante volteando tu teléfono.",
      },
      breakInReports: {
        title: "Informes de intrusión",
        description: "Alertas si alguien intenta acceder a tu caja fuerte.",
      },
    },
    pricing: {
      summerSale: "Rebajas de verano",
      monthly: "Mensual",
      perMonth: (price: string) => `${price} / mes`,
      twelveMonths: "12 meses",
      originalPrice: (price: string) => price,
      discountedPrice: (price: string) => price,
    },
  },
  autumnSale: {
    title: "REBAJAS DE OTOÑO",
    tagline: "Las hojas lo cubren todo…\n¡incluidos tus secretos!",
    buttonTitle: "Rebajas de Otoño",
  },
  halloweenSale: {
    title: "REBAJAS DE HALLOWEEN",
    tagline: "La noche esconde muchas cosas…\n¡especialmente las tuyas!",
    buttonTitle: "Rebajas de Halloween",
  },
  winterSale: {
    title: "REBAJAS DE INVIERNO",
    tagline: "Protejamos tus fotos bajo la nieve",
    buttonTitle: "Rebajas de Invierno",
  },
  springSale: {
    title: "REBAJAS DE PRIMAVERA",
    tagline: "Pasa a Premium con este descuento exclusivo de primavera",
    ultimateTagline:
      "Pasa a Ultimate con este descuento exclusivo de primavera",
    buttonTitle: "Rebajas de Primavera",
  },
  emailPromo: {
    title: "Oferta Exclusiva de Premium",
    upgradeButton: "Actualizar a Premium",
    yearlyTitle: "Premium Anual",
    decoyDescription:
      "Crear una bóveda falsa que se abre con una contraseña señuelo",
  },
  tabsPaywall: {
    premiumTab: "Premium",
    ultimateTab: "Ultimate",
    premiumTitle: "Desbloquea Premium para",
    premiumTitleHighlight: "Proteger Tu Bóveda",
    ultimateTitleStart: "Desbloquea ",
    ultimateTitleHighlight: "Ultimate",
    ultimateTitleEnd: " Para\nAcceder a Todas las Funciones",
    perMonth: "/mes",
  },
  trialFooter: {
    freeTrialDays: (days: number) => `${days} días\nde prueba gratis`,
    noFreeTrial: "Sin prueba\ngratuita",
    noCommitment: "Sin compromiso. Cancela cuando quieras.",
    cta: "Probar gratis",
    ctaMonthly: "Continuar",
    yearly: "Anual",
    monthly: "Mensual",
  },
  onboardingUltimateAlternate: {
    title: "Comienza tu prueba gratuita",
    premiumDescription: "Desbloquea excelentes herramientas de privacidad.",
    ultimateDescription: "La mejor experiencia de Photo Vault.",
    includesPremium: "Incluye Premium",
    trialPricing: (yearlyPrice: string, monthlyPrice: string) =>
      `7 días gratis, luego ${yearlyPrice} (${monthlyPrice}/mes)`,
    timeline: {
      today: "Hoy:",
      todayDescription: "comienza tu prueba gratuita",
      day5: "Día 5:",
      day5Description: "recibe recordatorio",
      day7: "Día 7:",
      day7Description: (yearlyPrice: string) => `se te cobrará ${yearlyPrice}`,
    },
    comparisonTable: {
      header: "Lo que obtienes",
    },
    didYouKnow: {
      label: "¿Sabías que?",
      statNumber: "3X",
      statDescription: "Los suscriptores obtienen 3 veces más tranquilidad",
    },
    pricing: {
      yearlyPlanTitle: "Plan anual",
      yearlyPlanSubtitle: (yearlyPrice: string) => `${yearlyPrice}/año`,
      yearlyAmount: (monthlyPrice: string) => `${monthlyPrice}/mes`,
      monthlyTitle: "Mensual",
      monthlyAmount: (monthlyPrice: string) => `${monthlyPrice}/mes`,
      popularBadge: "POPULAR",
    },
    ctaButton: "Iniciar prueba gratuita",
  },
  threeStepExpiration: {
    premiumExpired: "Tu Premium ha expirado",
    ultimateExpired: "La suscripción Ultimate ha expirado",
    freeExpired: "El Premium gratuito ha expirado",
    subtitle: "Tu cuenta ha sido degradada.",
    subtitlePremium: "Tu cuenta ha sido degradada.",
    subtitleUltimate: "Tu cuenta ha sido degradada.",
    allPremiumFeatures: "Todas las funciones Premium",
    allUltimateFeatures: "Todas las funciones Ultimate",
    spaceSaver: "Ahorro de espacio",
    disabled: "Desactivado",
    restoreMyProtection: "Restaurar acceso completo",
    seeWhatImLosing: "Ver lo que estoy perdiendo",
    photosSafeWarning:
      "Tus fotos están seguras, pero las funciones críticas están desactivadas.",
    continue: "Continuar",
    heresWhatYoureLosing: "Esto es lo que pierdes",
    allFeaturesDisabled:
      "Todas estas funciones premium se desactivarán en tu cuenta:",
    allFeaturesDisabledUltimate:
      "Todas estas funciones ultimate se desactivarán en tu cuenta:",
    back: "Atrás",
    stepOf: (current: number, total: number) => `Paso ${current} de ${total}`,
    restoreAllFeatures: "Restaurar todas las funciones",
    continueWithout: "Continuar (las funciones permanecen desactivadas)",
    allPremiumDetail:
      "Perderás el acceso a todas las funciones premium que mantienen tus fotos privadas seguras y organizadas.",
    cloudVaultDetail:
      "Tu copia de seguridad en la nube será eliminada. Si tu dispositivo se pierde o se daña, tus fotos privadas se perderán permanentemente.",
    cloudVaultDetailBold: "Tu copia de seguridad en la nube será eliminada.",
    cloudVaultDetailRest:
      "Si tu dispositivo se pierde o se daña, tus fotos privadas se perderán permanentemente.",
    spaceSaverDetail:
      "Las fotos ocuparán todo el espacio de almacenamiento en tu dispositivo. Ya no podrás comprimir y optimizar tu bóveda.",
    trashDetail:
      "Las fotos eliminadas accidentalmente no se podrán recuperar. Una vez eliminadas, se perderán permanentemente.",
    noAdsDetail:
      "Empezarás a ver anuncios en toda la app. Premium elimina toda la publicidad para una experiencia sin interrupciones.",
    decoyDetail:
      "Tu código señuelo dejará de funcionar. Cualquiera que lo conozca podría acceder a tu bóveda real.",
    chooseYourPlan: "Elige Tu Plan",
    restoreFullProtection: "Restaurar protección completa al instante",
    restorePremiumInstantly: "Restaurar Premium al instante",
    restoreUltimateInstantly: "Restaurar Ultimate al instante",
    instantlyRestored: "Restaurado al instante",
    reassurance:
      "Retoma justo donde lo dejaste — cada función se restaurará completamente en el momento en que te suscribas.",
    subscribeAndRestore: "Suscribirse y Restaurar",
    scrollForMore: "Desplaza para ver más",
    bestValue: "MEJOR VALOR",
    switchToBasicDescription:
      "Aún podrás ver y acceder a todas tus fotos existentes en la app. Tus álbumes y medios permanecen seguros en tu dispositivo.",
    viewAndAccess: "ver y acceder a todas tus fotos existentes",
    premiumFeaturesDisabled: "",
    restorePremium: "Restaurar Premium",
    restoreUltimate: "Restaurar Ultimate",
    choosePlanToReactivate: "Elige un plan para reactivar todas las funciones",
    perMonth: "/mes",
    twelveMonths: "Anual",
    oneMonth: "1 Mes",
  },
  backupPaywall: {
    title: "Copias de seguridad no activadas",
    subtitle:
      "Tus fotos y vídeos no están respaldados. Suscríbete a Premium para activar las copias de seguridad y desbloquear todas las funciones",
    subscribe: "Obtener Premium",
    cancelAnytime: "Sin compromiso. Cancela en cualquier momento",
  },
  lossAversion: {
    title: "Ni una sola foto se ha\nrespaldado nunca.",
    subtitle:
      "Cada foto está almacenada solo en este dispositivo. Si lo pierdes, desaparecen para siempre.",
    photosUnprotected: "fotos\nsin proteger",
    backedUp: "respaldadas",
    daysAtRisk: "días en riesgo",
    backupCoverage: "Cobertura de copia de seguridad",
    vaultProtected: (percent: number) =>
      `${percent}% de tu bóveda está protegido`,
    premiumTitle: "Lo que obtienes con Premium",
  },
}
